export const filterIds = (data, type) => data.filter(f => f.form_type === type).map(f => f.id);
export default filterIds;
